module.exports = __webpack_public_path__ + "6301c3a082aefc716fcd436f7cdfccb2.svg";